"use strict";
var tbody = document.querySelector("tbody");
var headers = document.querySelectorAll("th");
var currentColumn = null;
var currentDirection = "asc";
function clearActiveClasses() {
    var rows = Array.from(tbody.querySelectorAll("tr"));
    rows.forEach(function(row) {
        row.addEventListener("click", function() {
            rows.forEach(function(r) {
                return r.classList.remove("active");
            });
            row.classList.add("active");
        });
    });
}
clearActiveClasses();
headers.forEach(function(header, index) {
    header.addEventListener("click", function() {
        sortTable(index);
    });
});
function sortTable(cellIndex) {
    var rows = Array.from(tbody.querySelectorAll("tr"));
    if (currentColumn === cellIndex) currentDirection = currentDirection === "asc" ? "desc" : "asc";
    else {
        currentColumn = cellIndex;
        currentDirection = "asc";
    }
    rows.sort(function(a, b) {
        var aText = a.children[cellIndex].textContent.trim().replace(/[$,]/g, "");
        var bText = b.children[cellIndex].textContent.trim().replace(/[$,]/g, "");
        var aNum = Number(aText);
        var bNum = Number(bText);
        var comparison;
        if (isNaN(aNum) || isNaN(bNum)) comparison = aText.localeCompare(bText);
        else comparison = aNum - bNum;
        if (currentDirection === "asc") return comparison;
        else return -comparison;
    });
    rows.forEach(function(row) {
        return tbody.appendChild(row);
    });
}
function makeForm() {
    var form = document.createElement("form");
    form.classList.add("new-employee-form");
    var labelName = document.createElement("label");
    labelName.textContent = "Name:";
    var inputName = document.createElement("input");
    inputName.dataset.qa = "name";
    inputName.type = "text";
    inputName.name = "name";
    labelName.appendChild(inputName);
    form.appendChild(labelName);
    var labelPosition = document.createElement("label");
    labelPosition.textContent = "Position:";
    var inputPosition = document.createElement("input");
    inputPosition.dataset.qa = "position";
    inputPosition.type = "text";
    inputPosition.name = "position";
    labelPosition.appendChild(inputPosition);
    form.appendChild(labelPosition);
    var labelOffice = document.createElement("label");
    labelOffice.textContent = "Office:";
    var inputOffice = document.createElement("input");
    inputOffice.dataset.qa = "office";
    inputOffice.type = "text";
    inputOffice.name = "office";
    var officeSelect = document.createElement("select");
    officeSelect.name = "office";
    officeSelect.dataset.qa = "office";
    var offices = [
        "Tokyo",
        "Singapore",
        "London",
        "New York",
        "Edinburgh",
        "San Francisco"
    ];
    offices.forEach(function(city) {
        var option = document.createElement("option");
        option.value = city;
        option.textContent = city;
        officeSelect.appendChild(option);
    });
    labelOffice.appendChild(officeSelect);
    form.appendChild(labelOffice);
    var labelAge = document.createElement("label");
    labelAge.textContent = "Age:";
    var inputAge = document.createElement("input");
    inputAge.dataset.qa = "age";
    inputAge.type = "number";
    inputAge.name = "age";
    labelAge.appendChild(inputAge);
    form.appendChild(labelAge);
    var labelSalary = document.createElement("label");
    labelSalary.textContent = "Salary:";
    var inputSalary = document.createElement("input");
    inputSalary.dataset.qa = "salary";
    inputSalary.type = "number";
    inputSalary.name = "salary";
    labelSalary.appendChild(inputSalary);
    form.appendChild(labelSalary);
    var submit = document.createElement("button");
    submit.type = "submit";
    submit.textContent = "Save to table";
    form.appendChild(submit);
    document.body.appendChild(form);
    function showNotification(message, type) {
        var notification = document.createElement("div");
        notification.classList.add("notification", type);
        notification.dataset.qa = "notification";
        notification.textContent = message;
        document.body.appendChild(notification);
    }
    form.addEventListener("submit", function(e) {
        e.preventDefault();
        var nameInput = inputName.value.trim();
        var position = inputPosition.value.trim();
        var office = officeSelect.value;
        var age = parseInt(inputAge.value.trim());
        var salary = parseFloat(inputSalary.value.trim());
        if (!nameInput || !position || !office || isNaN(age) || isNaN(salary)) return showNotification("All fields are required.", "error");
        if (nameInput.length < 4) return showNotification("Name must be at least 4 characters long.", "error");
        if (age < 18 || age > 90) return showNotification("Age must be between 18 and 90.", "error");
        var newRow = document.createElement("tr");
        newRow.innerHTML = "\n      <td>".concat(nameInput, "</td>\n      <td>").concat(position, "</td>\n      <td>").concat(office, "</td>\n      <td>").concat(age, "</td>\n      <td>$").concat(salary.toLocaleString("en-US"), "</td>");
        tbody.appendChild(newRow);
        form.reset();
        return showNotification("New employee added successfully!", "success");
    });
}
makeForm();
tbody.addEventListener("click", function(e) {
    var cell = e.target;
    if (cell.tagName.toLowerCase() !== "td") return;
    var initialValue = cell.textContent.trim();
    var input = document.createElement("input");
    input.classList.add("cell-input");
    input.dataset.initialValue = initialValue;
    cell.textContent = "";
    cell.appendChild(input);
    input.focus();
    input.addEventListener("blur", function() {
        return saveChanges(cell, input);
    });
    input.addEventListener("keydown", function(b) {
        if (b.key === "Enter") saveChanges(cell, input);
    });
});
function saveChanges(cell, input, initialValue) {
    var newValue = input.value.trim();
    cell.textContent = newValue === "" ? initialValue : newValue;
    input.remove();
}

//# sourceMappingURL=index.1a122444.js.map
